export default __webpack_public_path__ + "static/qrcover-1cb10c3284da5e9e4c9ae1b23d65c921.jpg";